import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchDateBox,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffOrdersFinancial(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        applyFilters();
    };
    const [formQProvinceFromOptions, setFormQProvinceFromOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-financial/select-data/q-province-from').then(
            (response) => {
                setFormQProvinceFromOptions(response.data);
            }
        );
    }, []);
    const [formQCityFromOptions, setFormQCityFromOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-financial/select-data/q-city-from').then(
            (response) => {
                setFormQCityFromOptions(response.data);
            }
        );
    }, []);
    const [formQProvinceIdOptions, setFormQProvinceIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-financial/select-data/q-province-id').then(
            (response) => {
                setFormQProvinceIdOptions(response.data);
            }
        );
    }, []);
    const [formQCityIdOptions, setFormQCityIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-financial/select-data/q-city-id').then(
            (response) => {
                setFormQCityIdOptions(response.data);
            }
        );
    }, []);
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-financial/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [formQStateIdOptions, setFormQStateIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-financial/select-data/q-state-id').then(
            (response) => {
                setFormQStateIdOptions(response.data);
            }
        );
    }, []);
    const [formQCarrierIdOptions, setFormQCarrierIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-financial/select-data/q-carrier-id').then(
            (response) => {
                setFormQCarrierIdOptions(response.data);
            }
        );
    }, []);
    const [formQPaymentMethodIdOptions, setFormQPaymentMethodIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-financial/select-data/q-payment-method-id').then(
            (response) => {
                setFormQPaymentMethodIdOptions(response.data);
            }
        );
    }, []);
    const handlecomp2 = () => {
        applyFilters();
    };
    const [shopShare, setShopShare] = useState(null);
    const [postShare, setPostShare] = useState(null);
    const [taroffShare, setTaroffShare] = useState(null);
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQId('');
        setFilterQIdFrom('');
        setFilterQIdTo('');
        setFilterQProvinceFrom('');
        setFilterQCityFrom('');
        setFilterQProvinceId('');
        setFilterQCityId('');
        setFilterQShopId('');
        setFilterQGatewayKeyNew('');
        setFilterQGatewayId('');
        setFilterQStateId('');
        setFilterQCarrierId('');
        setFilterQPaymentMethodId('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQIdFrom && (newSearchParams['q-id-from'] = filterQIdFrom);
        filterQIdTo && (newSearchParams['q-id-to'] = filterQIdTo);
        filterQProvinceFrom && (newSearchParams['q-province-from'] = filterQProvinceFrom);
        filterQCityFrom && (newSearchParams['q-city-from'] = filterQCityFrom);
        filterQProvinceId && (newSearchParams['q-province-id'] = filterQProvinceId);
        filterQCityId && (newSearchParams['q-city-id'] = filterQCityId);
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQGatewayKeyNew && (newSearchParams['q-gateway-key-new'] = filterQGatewayKeyNew);
        filterQGatewayId && (newSearchParams['q-gateway-id'] = filterQGatewayId);
        filterQStateId && (newSearchParams['q-state-id'] = filterQStateId);
        filterQCarrierId && (newSearchParams['q-carrier-id'] = filterQCarrierId);
        filterQPaymentMethodId && (newSearchParams['q-payment-method-id'] = filterQPaymentMethodId);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQIdFrom, setFilterQIdFrom] = useState(allProps['q-id-from'] || '');
    const [filterQIdTo, setFilterQIdTo] = useState(allProps['q-id-to'] || '');
    const [filterQProvinceFrom, setFilterQProvinceFrom] = useState(
        allProps['q-province-from'] || ''
    );
    const [filterQCityFrom, setFilterQCityFrom] = useState(allProps['q-city-from'] || '');
    const [filterQProvinceId, setFilterQProvinceId] = useState(allProps['q-province-id'] || '');
    const [filterQCityId, setFilterQCityId] = useState(allProps['q-city-id'] || '');
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQGatewayKeyNew, setFilterQGatewayKeyNew] = useState(
        allProps['q-gateway-key-new'] || ''
    );
    const [filterQGatewayId, setFilterQGatewayId] = useState(
        allProps['q-gateway-id'] || ''
    );
    const [filterQStateId, setFilterQStateId] = useState(allProps['q-state-id'] || '');
    const [filterQCarrierId, setFilterQCarrierId] = useState(allProps['q-carrier-id'] || '');
    const [filterQPaymentMethodId, setFilterQPaymentMethodId] = useState(
        allProps['q-payment-method-id'] || ''
    );
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-financial/table-data', {
            size: tableSize,
            page: tablePage,
            q_id: filterQId,
            q_id_from: filterQIdFrom,
            q_id_to: filterQIdTo,
            q_province_from: filterQProvinceFrom,
            q_city_from: filterQCityFrom,
            q_province_id: filterQProvinceId,
            q_city_id: filterQCityId,
            q_shop_id: filterQShopId,
            q_gateway_key_new: filterQGatewayKeyNew,
            q_gateway_id: filterQGatewayId,
            q_state_id: filterQStateId,
            q_carrier_id: filterQCarrierId,
            q_payment_method_id: filterQPaymentMethodId,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
        }).then((response) => {
            setTableData(response.data);
        });
        postData('/api/panel/page/taroff-orders-financial/financial-data', {
            size: tableSize,
            page: tablePage,
            q_id: filterQId,
            q_id_from: filterQIdFrom,
            q_id_to: filterQIdTo,
            q_province_from: filterQProvinceFrom,
            q_city_from: filterQCityFrom,
            q_province_id: filterQProvinceId,
            q_city_id: filterQCityId,
            q_shop_id: filterQShopId,
            q_gateway_key_new: filterQGatewayKeyNew,
            q_gateway_id: filterQGatewayId,
            q_state_id: filterQStateId,
            q_carrier_id: filterQCarrierId,
            q_payment_method_id: filterQPaymentMethodId,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
        }).then((response) => {
            setShopShare(response.shop_share);
            setPostShare(response.post_share);
            setTaroffShare(response.taroff_share);
        });
    }, [searchParams, modal, props]);
    return (
        <PanelBox>
            <Title>جزئیات مالی سفارشات</Title>
            <TextView>سهم فروشگاه: </TextView>
            <TextView>{shopShare?.toLocaleString() ?? '...'}</TextView>
            <TextView>سهم پست: </TextView>
            <TextView>{postShare?.toLocaleString() ?? '...'}</TextView>
            <TextView>سهم تعارف: </TextView>
            <TextView>{taroffShare?.toLocaleString() ?? '...'}</TextView>
            <Row>
                <RightComponents>
                    <Title>جزئیات مالی سفارشات</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        جستجو
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <SearchBox onEnter={applyFilters}
                    label={'شناسه'}
                    value={filterQId}
                    onChange={setFilterQId}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'شناسه از'}
                    value={filterQIdFrom}
                    onChange={setFilterQIdFrom}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'شناسه تا'}
                    value={filterQIdTo}
                    onChange={setFilterQIdTo}
                    width={'120px'}
                />
                <MultiSelectBox
                    label={'استان مبدا'}
                    options={formQProvinceFromOptions}
                    value={filterQProvinceFrom}
                    onChange={setFilterQProvinceFrom}
                />
                <MultiSelectBox
                    label={'شهر مبدا'}
                    options={formQCityFromOptions}
                    value={filterQCityFrom}
                    onChange={setFilterQCityFrom}
                />
                <MultiSelectBox
                    label={'استان مقصد'}
                    options={formQProvinceIdOptions}
                    value={filterQProvinceId}
                    onChange={setFilterQProvinceId}
                />
                <MultiSelectBox
                    label={'شهر مقصد'}
                    options={formQCityIdOptions}
                    value={filterQCityId}
                    onChange={setFilterQCityId}
                />
                <MultiSelectBox
                    label={'فروشگاه'}
                    options={formQShopIdOptions}
                    value={filterQShopId}
                    onChange={setFilterQShopId}
                />
                <SearchBox onEnter={applyFilters}
                    label={'کلید گیت وی جدید'}
                    value={filterQGatewayKeyNew}
                    onChange={setFilterQGatewayKeyNew}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'کلید گیت وی'}
                    value={filterQGatewayId}
                    onChange={setFilterQGatewayId}
                    width={'120px'}
                />
                <MultiSelectBox
                    label={'وضعیت'}
                    options={formQStateIdOptions}
                    value={filterQStateId}
                    onChange={setFilterQStateId}
                />
                <MultiSelectBox
                    label={'حامل'}
                    options={formQCarrierIdOptions}
                    value={filterQCarrierId}
                    onChange={setFilterQCarrierId}
                />
                <MultiSelectBox
                    label={'شیوه ی پرداخت'}
                    options={formQPaymentMethodIdOptions}
                    value={filterQPaymentMethodId}
                    onChange={setFilterQPaymentMethodId}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج از'}
                    value={filterQInsertTimeFrom}
                    onChange={setFilterQInsertTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج تا'}
                    value={filterQInsertTimeTo}
                    onChange={setFilterQInsertTimeTo}
                    width={'100px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>مبداء</TableColumn>
                        <TableColumn mobile={false}>مقصد</TableColumn>
                        <TableColumn mobile={false}>مبلغ کل</TableColumn>
                        <TableColumn mobile={false}>هزینه ارسال</TableColumn>
                        <TableColumn mobile={false}>مالیات ارسال</TableColumn>
                        <TableColumn mobile={false}>جمع سهم فروشگاه</TableColumn>
                        <TableColumn mobile={false}>جمع سهم پست</TableColumn>
                        <TableColumn mobile={false}>جمع سهم تعارف</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_shop_id_city_id_title}</TextView>
                                <TextView>{row.text_shop_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView bold={true}>
                                        {row.text_city_id_province_id_title}
                                    </TextView>
                                    <TextView>{row.text}</TextView>
                                    <TextView bold={true}>{row.text_city_id_title}</TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_customer_name}</TextView>
                                    <TextView>{row.text_2}</TextView>
                                    <TextView>{row.text_customer_mobile}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true} format={'money'}>
                                    {row.text_total_list_price}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true} format={'money'}>
                                    {row.text_total_shipping_price}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true} format={'money'}>
                                    {row.text_total_shipping_tax}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true} format={'money'}>
                                    {row.text_total_shop_share}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true} format={'money'}>
                                    {row.text_total_post_share}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true} format={'money'}>
                                    {row.text_total_taroff_share}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-datetime-normal'}>
                                    {row.text_insert_time}
                                </TextView>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
